'use client';

import React from 'react';
import { usePrevious } from './usePrevious';
import { useIsMounted } from './useIsMounted';

const isValueSet = <T extends readonly unknown[]>(_value: unknown, isMounted: boolean): _value is T => {
  return isMounted;
};

export const useEffectDidUpdate = <T extends readonly unknown[]>(effect: (...values: T) => void, values: T): void => {
  const isMounted = useIsMounted();
  const prev = usePrevious(values);
  React.useEffect(() => {
    if (isValueSet<T>(prev, isMounted)) {
      return effect(...prev);
    }
  });
};
